<template>
<div class="activity project">
    <figure v-if="item.thumb">
        <img :src="item.thumb.url" />
    </figure>
    <div class="activity__content">
        <p class="title is-6">{{item.release_date}} <i>/</i> {{type}}</p>
        <div class="columns">
            <div class="column"><h3 class="title is-4">{{item.title}}</h3></div>
        </div>
        <div class="content" v-html="item.excerpt"></div>
    </div>
</div>
</template>

<script>
export default {
    name    :   'ProjectActivity',
    props   :   ['type', 'item']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/ProjectActivity.vue